import { render, staticRenderFns } from "./LeisureLeftComp.vue?vue&type=template&id=446e4778&scoped=true&"
import script from "./LeisureLeftComp.vue?vue&type=script&lang=js&"
export * from "./LeisureLeftComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e4778",
  null
  
)

export default component.exports